import { useState, useEffect } from 'react';
import axios from 'axios';
import { ChangeLog } from 'api/Changelog/types';

type ChangelogsResponse = {
  id: string;
  createdTime: string;
  fields: ChangeLog;
};

const useChangelog = (): {
  changelog: ChangelogsResponse[];
  loading: boolean;
} => {
  const [changelog, setChangelog] = useState<ChangelogsResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchChangelog = async () => {
      setLoading(true);
      try {
        // Static export of the former Airtable changelog base (shut down 2026-07-18)
        const response = await axios.get(`/changelog.json`);
        setChangelog(response.data.records);
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };

    fetchChangelog();
  }, []);

  return { changelog, loading };
};

export default useChangelog;
